<template>
  <div>
    <el-form ref="form" :model="curInput.input" :rules="rules" label-width="100px">
      <el-form-item label="是否唯一" v-if="curInput.input.write_type != 90">
        <el-radio-group v-model="curInput.input.is_unique">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="填写类型" prop="write_type">
        <el-select v-model="curInput.input.write_type" placeholder="请选择填写类型" class="h-40 w-200">
          <el-option v-for="item in writeType" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="默认值" prop="default" v-if="curInput.input.write_type != 90">
        <el-input v-model.trim="curInput.input.write_default" class="h-40 w-200"></el-input>
      </el-form-item>
      <el-form-item label="公式" prop="formula" v-if="curInput.input.write_type == 90">
        <el-input v-model.trim="curInput.input.formula" class="h-40 w-200" disabled></el-input>
        <el-button type="primary" @click="editFormula">公式编辑</el-button>
      </el-form-item>
    </el-form>
    <textlen-config :rules="rules" :config="curInput.input" :maxCount="11" :limitMax="true" v-if="curInput.input.write_type == TYPE_NUMBER"></textlen-config>

    <textlen-config :rules="rules" :config="curInput.input" :maxCount="18" :limitMax="true" :disabled="true" v-else-if="curInput.input.write_type == TYPE_IDCARD"></textlen-config>

    <textlen-config :rules="rules" :config="curInput.input" :maxCount="20" :limitMax="true" :disabled="disabled" v-else-if="curInput.input.write_type == TYPE_FLOATNUMBER" :isdecimal="isdecimal"></textlen-config>
    
    <textlen-config :rules="rules" :config="curInput.input" :maxCount="30" :limitMax="true" :disabled="disabled" v-else-if="curInput.input.write_type == TYPE_BANK"></textlen-config>

    <textlen-config :rules="rules" :config="curInput.input" :maxCount="256" :limitMax="true" v-else></textlen-config>
    
    <!-- 最大最小值限制，只有数字类型才有 -->
    <template v-if="isNumber">
      <el-form ref="form" :model="curInput.input" :rules="rules" label-width="100px">
        <el-form-item label="最小值限制" prop="default">
          <el-input type="number" v-model="curInput.input.min_limit" class="h-40 w-200"></el-input>
        </el-form-item>
        <el-form-item label="最大值限制" prop="default">
          <el-input type="number" v-model="curInput.input.max_limit" class="h-40 w-200"></el-input>
        </el-form-item>
      </el-form>
    </template>
    <!-- 最大最小值限制，只有数字类型才有 -->

    <el-dialog ref="dialog" title="编辑公式表达(fx)" :modal="false" :close-on-click-modal="false">
      <div class="form-tips fz-14 m-b-10">使用说明：可以用各种控件计算出这个控件的值，目前支持四则运算，字段名用英文半角双引号导入，+-*/四则运算符号，并支持括号()。特别的，若要对外键进行运算，需加上对应关联的表的字段名，如：需外键a所关联表的字段b，则写a.b。</div>
      <el-input
        type="textarea"
        :rows="8"
        placeholder="请输入内容"
        v-model="explain">
      </el-input>
      <div class="m-b-10 m-t-10">公式</div>
      <el-input
        type="textarea"
        :rows="8"
        placeholder="请输入内容"
        v-model="formulaData">
      </el-input>
      <div class="form-tips fz-14">示例：("input_1" + "num")*("money" * 0.15)</div>
      <span slot="footer" class="dialog-footer m-b-10">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import textlenConfig from './textlenConfig'
  import modelConfig from '../../../config/modelConfig'
  export default {
    props: ['curInput', 'inputList'],
    data() {
      return {
        writeType: [
          { id: 10, name: '字符串' },
          { id: 20, name: '整型' },
          { id: 30, name: '英文' },
          { id: 40, name: '数字或英文' },
          { id: 50, name: '手机' },
          { id: 60, name: '邮箱' },
          { id: 70, name: '身份证号码' },
          { id: 80, name: '浮点型' },
          { id: 90, name: '公式' },
          { id: 100, name: '银行账号' }
        ],
        rules: {
          write_type: [
            { required: true, message: '请选择填写类型' }
          ],
          default: []
        },
        isdecimal: false,
        // isShow: false, // 公式弹窗显示
        formInput: [],
        selectShow: false,
        text: '',
        view: false,
        formula: [
          {
            name: 'SUM',
            content: 'sum[]'
          },
          {
            name: 'AVG',
            content: 'AVG[]'
          },
          {
            name: 'MIN',
            content: 'MIN[]'
          },
          {
            name: 'MAX',
            content: 'MAX[]'
          }
        ],
        explain: '',  // 可用变量说明
        formulaData: '' // 输入的公式
      }
    },
    components: {
      textlenConfig
    },
    mixins: [modelConfig],
    created() {
      if (this.curInput.input.write_type == this.TYPE_FLOATNUMBER) { // 如果类型是浮点类型
        this.isdecimal = true
      } else {
        this.isdecimal = false
      }
    },
    methods: {
      makeExplain() { // 可用字段说明
        this.explain = ''
        this.explain += '可使用的变量字段\n'
        _(this.inputList).forEach((res) => {
          if ((res.default.type == this.TYPE_INPUTTEXT &&
              res.input &&
              (res.input.write_type == this.TYPE_NUMBER ||
               res.input.write_type == this.TYPE_FLOATNUMBER ||
               res.input.write_type == this.TYPE_FORMULA)) ||
              res.default.type == this.TYPE_RADIO ||
              res.default.type == this.TYPE_SELECT) { // 数字类型
            this.explain += `${res.default.title} "${res.default.name}"\n`
          } else if (res.default.type == this.TYPE_FOREIGNKEY) {  // 外键
            _(res.key.show_name).forEach((showName) => {
              this.explain += `${res.default.title} "${res.default.name}.${showName}"\n`
            })
          }
        })
      },
      editFormula() {
        this.openDialog()
        this.makeExplain()
        this.formInput.splice(0, this.formInput.length)
        this.inputList.forEach((item) => {
          if (item.default.type == 10 && item.input.write_type != 90) {
            this.formInput.push(item)
          }
        })
      },
      // 获取光标位置插入
      insertHtmlAtCaret (html) {
        var sel, range
        if (window.getSelection) {
          // IE9 and non-IE
          sel = window.getSelection()
          if (sel.getRangeAt && sel.rangeCount) {
            range = sel.getRangeAt(0)
            range.deleteContents()
            // Range.createContextualFragment() would be useful here but is
            // non-standard and not supported in all browsers (IE9, for one)
            var el = document.createElement('div')
            el.innerHTML = html
            var frag = document.createDocumentFragment()
            var node
            var lastNode
            while ((node = el.firstChild)) {
              lastNode = frag.appendChild(node)
            }
            range.insertNode(frag)
            // Preserve the selection
            if (lastNode) {
              range = range.cloneRange()
              range.setStartAfter(lastNode)
              range.collapse(true)
              sel.removeAllRanges()
              sel.addRange(range)
            }
          }
        } else if (document.selection && document.selection.type != "Control") {
          // IE < 9
          document.selection.createRange().pasteHTML(html)
        }
      },
      select(item, type) {
        document.getElementById('formula').focus()
        let content = type == 1 ? item.default.title : item.content
        this.insertHtmlAtCaret(content)
        this.selectShow = false
      },
      openDialog() {
        this.formulaData = this.curInput.input.formula
        this.$refs.dialog.open()
      },
      closeDialog() {
        this.$refs.dialog.close()
      },
      submit() {
        this.curInput.input.formula = this.formulaData
        this.closeDialog()
      }
    },
    watch: {
      'curInput.input.write_type'() { // 监听Input类型改变限制条件
        let writeType = this.curInput.input.write_type
        if (writeType == this.TYPE_NUMBER) {
          if (this.curInput.input.write_min > 11) {
            this.curInput.input.write_min = 11
          }
          if (this.curInput.input.write_max > 11) {
            this.curInput.input.write_max = 11
          }
        } else if (writeType == this.TYPE_IDCARD) { // 身份证号码，固定为18位
          this.curInput.input.write_min = 0
          this.curInput.input.write_max = 18
        } else if (writeType == this.TYPE_FLOATNUMBER) {
          this.isdecimal = true
        } else if (writeType == this.TYPE_BANK) {
          this.curInput.input.write_min = 0
          this.curInput.input.write_max = 30
        } else {
          this.isdecimal = false
        }
      }
    },
    computed: {
      isNumber() {
        let writeType = this.curInput.input.write_type
        return writeType == this.TYPE_NUMBER ||
               writeType == this.TYPE_FLOATNUMBER ||
               writeType == this.TYPE_FORMULA
      }
    }
  }
</script>

<style>
  .form-input-wrap:hover {
    color: #ffffff;
    background-color: #5bb1fa;
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// textConfig.vue?74075dae